import { faCircleInfo, faXmark } from '@fortawesome/pro-light-svg-icons'
import { Fragment, useCallback, useEffect, useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { Link } from 'react-router-dom'
import { ButtonPrimary } from '../../../../../../../../baseComponents/Button'
import { ModalBigCentered } from '../../../../../../../../baseComponents/Modal'
import { ModalOpenedTy } from '../../../../../../../../baseComponents/Modal/types'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import TwinIcon from '../../../../../../../../baseComponents/TwinIcon'
import { BuildedOrder, RowData } from '../../../../../../../../baseComponents/TwinTable/types'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import InputQuantityButtons from '../../../../../../../../forms/Input/InputQuantityButtons'
import twinFetchPost, { twinFetchPostJSON } from '../../../../../../../../utils/globals/data'
import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'
import locations from '../../../../../../../../utils/globals/locations'
import { makeVariantGroupMainIdLast, sortVariantProducts } from '../../../../../../../../utils/globals/product'
import withLoading from '../../../../../../../../utils/hoc/withLoading'
import useIsLoading from '../../../../../../../../utils/hooks/useIsLoading'
import { AllReduxPayloads } from '../../../../../../../../utils/reducers'
import { VariantsPayload } from '../../../../../../../../utils/reducers/products/variants'
import { OrderURLsTable } from '../../../../types'
import { createModalComplexProductMatrixStructureTPV } from './functions'
import './modalcomplexproductvariantsorder.sass'
import { ComplexProductVariantsOrderData, ModalComplexTpvVariantGroupOrder } from './types'

type ModalComplexProductVariantsOrderProps = ModalComplexProductVariantsOrderLogicProps & {
}

const ModalComplexProductVariantsOrder: React.FC<ModalComplexProductVariantsOrderProps> = ({ setOpened, allRowData, headerData, orderURLs, ...rest }) => {
    const { myOnSubmit, allVariantData, myOnClick, value, loading, changeQuantity } = useModalComplexProductVariantsOrderLogic({ setOpened, allRowData, orderURLs, ...rest, headerData })
    const renderThis: JSX.Element[] = []
    let numberListGroup = 1
    const valueArray = value.valueArray
    if (allVariantData?.byVariantUsedId) {
        renderThis.push(<ProductVariantsChildrenListInner key={numberListGroup + '_row'} allVariantData={allVariantData?.byVariantUsedId} numberListGroup={numberListGroup} onClick={myOnClick} optionalVariant={false} variantGroupValueTranslations={allVariantData?.variantGroupValueTranslations} myValue={valueArray[numberListGroup - 1]} variantGroupOrder={allVariantData?.variantGroupOrder} />)
        if (valueArray.length) {
            let myDict = allVariantData?.byVariantUsedId
            for (const element of valueArray) {
                numberListGroup++
                const haveItem = myDict?.[element].item
                myDict = myDict?.[element]?.nextItems
                if (myDict && Object.keys(myDict)?.length) {
                    renderThis.push(<ProductVariantsChildrenListInner key={numberListGroup + '_row'} allVariantData={myDict} numberListGroup={numberListGroup} onClick={myOnClick} optionalVariant={haveItem} variantGroupValueTranslations={allVariantData?.variantGroupValueTranslations} myValue={valueArray[numberListGroup - 1]} variantGroupOrder={allVariantData?.variantGroupOrder} />)
                }
            }
        }
    }
    return (
        <ModalBigCentered className='modal_config_variant' opened={true} setOpened={() => setOpened(null)} onClickOut={false}>
            <CustomVariantTitleHeader setOpened={setOpened} allRowData={allRowData || {}} />
            <div className='p-25 gap-y-24 product_variants_parent_container overflow-hidden overflow-y-auto flex flex-col items-center'>
                {renderThis}
                {(!value?.selectedItem && !loading) ? null :
                    <div className='flex flex-col w-full gap-y-15 items-start'>
                        <div className='medium14'><TwinTrans transKey='quantity'>Cantidad</TwinTrans></div>
                        <InputQuantityButtons onChange={changeQuantity} value={value?.quantity || 0} />
                    </div>
                }
            </div>
            <div className='h-100 flex items-center justify-between px-30 py-25 border-b border-gray-D6 bg-gray-FB config_variant_footer'>
                <div className='cursor-pointer ml-auto hover:text-green-21' onClick={() => setOpened(null)}><TwinTrans transKey='cancel'>Cancelar</TwinTrans></div>
                <ButtonPrimary type='submit' disabled={!value?.selectedItem && !loading} className='ml-25 regular14' onClick={() => myOnSubmit(value.selectedItem)} ><TwinTrans transKey='select'>Seleccionar</TwinTrans></ButtonPrimary>
            </div>
        </ModalBigCentered>
    )
}

type ModalComplexProductVariantsOrderLogicProps = ModalEditComponentProps & ReduxVariants & {
    orderURLs: OrderURLsTable
    getCompleteData: (order?: BuildedOrder) => Promise<void>
    headerData: TwinDictionary
}

const useModalComplexProductVariantsOrderLogic = ({ headerData, allRowData, variants, orderURLs, setOpened, getCompleteData, onSubmit }: ModalComplexProductVariantsOrderLogicProps) => {
    const { endLoading, loading, startLoading } = useIsLoading()
    const [allVariantData, setAllVariantData] = useState<ComplexProductVariantsOrderData | null>(null)
    const [value, setValue] = useState<{ valueArray: number[], selectedItem: TwinDictionary | null, quantity?: number }>({ valueArray: [], selectedItem: null })
    const getData = useCallback(async () => {
        const params: TwinDictionary = {}
        for (const key of orderURLs?.getSubProducts[1]) {
            params[key] = headerData[key]
        }
        let subProducts = await twinFetchPostJSON(orderURLs?.getSubProducts[0], { 'ProductId': allRowData?.ProductId, ...params })
        const { orderedGroupsJson, myMain } = makeVariantGroupMainIdLast(variants?.orderedGroupsJson || {}, allRowData?.VariantGroupMainId, subProducts)
        const variantsParsed: any = { ...variants, orderedGroupsJson }
        subProducts = sortVariantProducts(subProducts, variantsParsed)
        let myOrder: TwinDictionary = {}
        for (const key in subProducts) {
            const subProduct = subProducts[key]
            myOrder[subProduct.id] = key
        }
        const currentDictionary: TwinDictionary = {}
        const variantAddonsArr: TwinDictionary[] = []
        if (allRowData?.completeData?.tableData) {
            for (const element of allRowData?.completeData?.tableData || {}) {
                if (element.OrderVariantGroupId === allRowData?.OrderVariantGroupId) {
                    if(!element.OrderProductId){
                        currentDictionary[element['ProductId']] =  element
                    }else {
                        variantAddonsArr.push(element)
                    }
                }
            }
        }
        const { byVariantUsedId, variantGroupValueTranslations, variantGroupOrder } = createModalComplexProductMatrixStructureTPV(subProducts, variants, myMain)
        setAllVariantData({ byVariantUsedId, variantGroupValueTranslations, selectedVariantComplexDict: {}, orderSelectedVariantList: [], variantGroupOrder })
    }, [allRowData, variants, headerData, orderURLs?.getSubProducts])

    const myOnClick = useCallback((pos: number, value: number, selectedItem: TwinDictionary | null) => {
        setValue((old) => {
            const copy = JSON.parse(JSON.stringify(old))
            copy.valueArray[pos-1] = value
            copy.valueArray.splice(pos)
            copy.selectedItem = selectedItem
            if (selectedItem) {
                copy.quantity = 1
            }
            return copy
        })
    }, [setValue])

    const changeQuantity = useCallback((value: string) => {
        setValue((old) => {
            const copy = JSON.parse(JSON.stringify(old))
            copy.quantity = parseInt(value)
            return copy
        })
    }, [setValue])
    
    const onPreSubmit = useCallback(() => {
        if (value.selectedItem && value.quantity) {
            const result: TwinDictionary = {
                ...value.selectedItem,
                ...orderURLs?.createData[1],
                quantity: value.quantity,
                ProductId: value.selectedItem['id'],
                id: undefined,
            }
            return result
        }
        return false
    }, [value.selectedItem, orderURLs?.createData, value.quantity])

    const myOnSubmit: any = useCallback(async() => {
        startLoading()
        const selectedValue = onPreSubmit()
        if (selectedValue) {
            const response = await twinFetchPost(orderURLs?.createData[0], {
                createProductBulk: [selectedValue],
                SuperProductParentId: allRowData?.id
            })
            if (onSubmit) {
                await onSubmit(response, selectedValue)
            } else {
                await getCompleteData()
            }
        }
        endLoading()
        setOpened(null)
        //@ts-ignore
        await document.querySelector('.add_product_row.input_table_header_row')?.click()
    }, [getCompleteData, setOpened, onSubmit, startLoading, endLoading, orderURLs?.createData, allRowData?.id, onPreSubmit])

    useEffect(() => {
        getData()
    }, [getData])

    return { myOnSubmit, allVariantData, myOnClick, value, loading, changeQuantity }
}

interface CustomVariantTitleHeaderProps {
    setOpened: (value: React.SetStateAction<ModalOpenedTy>) => void
    allRowData: RowData
}

const CustomVariantTitleHeader: React.FC<CustomVariantTitleHeaderProps> = ({ setOpened, allRowData }) => {
    return (
        <div className='h-75 flex items-center justify-between py-20 px-25 border-b border-gray-D6 bg-gray-FB config_variants_header'>
            <div className='flex flex-col items-start gap-y-10'>
                <div className='regular18'><TwinTrans transKey='configVariants'>Configurar variantes</TwinTrans></div>
                <div className='flex items-center gap-x-10'>
                    <div className='text-gray-97 regular14'>{allRowData?.['ProductLangs.name'] || allRowData?.['name']} - {allRowData?.['reference']}</div>
                    <Link to={locations.product + '/' + allRowData?.id + '/variants'} style={{ height: 16 }} target='_blank'><TwinIcon icon={faCircleInfo} fontSize={16} className='text-gray-97 mb-2 cursor-pointer' /></Link>
                </div>
            </div>
            <div onClick={() => setOpened(null)} className='cursor-pointer hover:text-green-21 flex gap-x-10 items-center'>
                <TwinIcon icon={faXmark} className='mb-1' fontSize={25} />
            </div>
        </div>
    )
}

interface ProductVariantsOrderListInnerProps {
    allVariantData: { [key: number]: { nextItems: TwinDictionary, item: TwinDictionary } }
    variantGroupValueTranslations: TwinDictionary
    variantGroupOrder: ModalComplexTpvVariantGroupOrder
    onClick: (pos: number, value: number, selectedItem: TwinDictionary | null) => void
    numberListGroup: number
    myValue?: number
    optionalVariant: boolean
}

const ProductVariantsChildrenListInner: React.FC<ProductVariantsOrderListInnerProps> = ({ allVariantData, onClick, optionalVariant, variantGroupValueTranslations, numberListGroup, myValue, variantGroupOrder }) => {
    const renderThis: JSX.Element[] = []
    const firstKey = Object.keys(allVariantData)?.[0]
    let parentName = variantGroupValueTranslations[firstKey]?.parentName || ''
    let parentId = variantGroupValueTranslations[firstKey]?.parentId || ''
    const items = variantGroupOrder[parentId]
    const renderSecondChildren: JSX.Element[] = []
    if(items){
        for (const element of items) {
           const id = element.id
           if (allVariantData[id]){
                const myItem = allVariantData[id]?.item
                renderSecondChildren.push(
                    <ProductVariantOrderElement name={variantGroupValueTranslations[id]?.name} onClick={() => onClick(numberListGroup, id, myItem || null)} isChecked={myValue === id} key={id} />
                )
            }
        }
    }
    renderThis.push(<ProductVariantOrderGroupComponent optionalVariant={optionalVariant} name={numberListGroup + '.' + parentName} children={renderSecondChildren} key={parentId} />)
    return (
        <Fragment>
            {renderThis}
        </Fragment>
    )
}


interface ProductVariantOrderGroupComponentProps {
    children?: React.ReactNode
    name: string
    optionalVariant?: boolean
}

const ProductVariantOrderGroupComponent: React.FC<ProductVariantOrderGroupComponentProps> = ({children, name, optionalVariant}) => {
    return (
        <div className='flex flex-col w-full gap-y-15 items-start product_variant_group'>
            <div className='flex gap-x-10'>
                <div className='medium14'>{name}</div>
                {optionalVariant ? <div className='regular14 text-gray-97'><TwinTrans transKey='optional'>(Opcional)</TwinTrans></div> : null}
            </div>
            <div className='flex flex-wrap gap-15 product_variant_elements_list'>
                {children}
            </div>
        </div>
    )
}

interface ProductVariantOrderElementProps {
    name: string
    onClick: () => void
    isChecked: boolean
}

const ProductVariantOrderElement: React.FC<ProductVariantOrderElementProps> = ({name, isChecked, onClick}) => {
    return (
        <div onClick={onClick} className={'product_variant_element py-10 px-20 hover:bg-green-DB cursor-pointer min-w-50 rounded-md border border-gray-D6 flex items-center justify-center ' + (isChecked ? 'bg-green-DB' : '')}>{name}</div>
    )
}

const VariantsDispatch = {
    setVariants: (payload: VariantsPayload) => ({ type: 'CHANGE_VARIANTS', payload }),
}

export type ReduxVariants = ConnectedProps<typeof VariantsConnect>
const mapVariantsConnector = (state: AllReduxPayloads) => ({ variants: state.variants })
const VariantsConnect = connect(mapVariantsConnector, VariantsDispatch)

const VariantsConnectLoading = withLoading(ModalComplexProductVariantsOrder, [{ fetchUrl: '/api/app/product/productVariant/getAllVariantsComplete', propName: 'variants', setFunctionName: 'setVariants' }])

const ModalComplexProductVariantsOrderConnect = VariantsConnect(VariantsConnectLoading)

export default ModalComplexProductVariantsOrderConnect